import { useEffect, useState } from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import pages from "./content/pages.json";

export const App = () => {
  const location = useLocation();

  // On narrow screens the nav becomes a slide-in sidebar behind this toggle
  const [menuOpen, setMenuOpen] = useState(false);

  // Start each page at the top (and close the sidebar) when navigating
  useEffect(() => {
    window.scrollTo(0, 0);
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <div className="site">
      <header className="site-header">
        <NavLink to="/" className="site-name">
          Dash<span className="site-name-accent"> Dixon</span>
        </NavLink>
        <button
          className="nav-toggle"
          aria-label="Open menu"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          &#9776;
        </button>
        {menuOpen && (
          <div className="nav-backdrop" onClick={() => setMenuOpen(false)} />
        )}
        <nav className={menuOpen ? "site-nav open" : "site-nav"}>
          <button
            className="nav-close"
            aria-label="Close menu"
            onClick={() => setMenuOpen(false)}
          >
            &#10005;
          </button>
          <NavLink to="/" end>Home</NavLink>
          <NavLink to="/blog">Blog</NavLink>
          {pages.map((page) => (
            <NavLink key={page.slug} to={`/${page.slug}`}>{page.title}</NavLink>
          ))}
          <NavLink to="/contact">Contact</NavLink>
        </nav>
      </header>

      <main className="site-main">
        <Outlet />
      </main>

      <footer className="site-footer">
        <p>&copy; {new Date().getFullYear()} Dash Dixon</p>
      </footer>
    </div>
  );
};
